import {
  GroupItemKinds,
  GroupKind,
} from '@care/navigation/dist/components/GlobalNavIA/NavLinkList/NavLinkList';
import { getVerticalIntroductoryLink } from './getVerticalIntroductoryLink';

/**
 * This function creates a "More info" column for the navigation menu.
 * It includes a label, a vertical introductory link, and common links for the specified key.
 * @param baseURL - The base URL for the application.
 * @param key - The key representing the vertical category (e.g., 'childCareLinks').
 * @param moreInfoCommonLinks - An array of common links to be included in the "More info" column.
 * @returns A GroupKind object representing the "More info" column.
 */

export const createMoreInfoColumn = (
  baseURL: string,
  key: string,
  moreInfoCommonLinks: GroupItemKinds[]
): GroupKind => {
  const moreInfoLabel: GroupItemKinds = {
    kind: 'label',
    id: 'more-info-label',
    value: 'More info',
  };
  const verticalIntroductoryLink = getVerticalIntroductoryLink(baseURL, key);

  return {
    id: 'more-info-column',
    kind: 'group',
    items: [moreInfoLabel, verticalIntroductoryLink, ...moreInfoCommonLinks],
  };
};
